import { usePatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder } from '@fukuri-admins/apis/client/gen/endpoints';

export const usePatchClientPortalItemsReorder =
  usePatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsReorder;
